import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "description",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "author",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "num_of_pages",
    type: "number",
    sortable: true,
    searchable: true,
  },
];

export default function List() {
  return <ResourceListPage url="books" columns={columns} />;
}
